/** Provides a React context for managing and toggling global task list filters. */
import { createContext, useContext } from 'react';

export const FilterContext = createContext(null);

const DEFAULT_FILTER_STATE = {
  hiddenProjects: [],
  hiddenContexts: [],
  toggleProjectVisibility: () => {},
  toggleContextVisibility: () => {},
  setHiddenProjects: () => {},
  setHiddenContexts: () => {},
  cleanupHidden: () => {},
};

export const useFilterContext = () => {
  const context = useContext(FilterContext);
  return context || DEFAULT_FILTER_STATE;
};
